import Currencies from './Currencies.component';

export default Currencies;
